import { Component } from '@angular/core';

import ProjectLinks from 'src/app/common/project.links';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  public get contactUsLink(): string {
    return ProjectLinks.LINK_CONTACT_US;
  }

  public get donateLink(): string {
    return ProjectLinks.LINK_DONATE;
  }

  public get termsLink(): string {
    return ProjectLinks.LINK_TERMS;
  }

  public get aboutUsLink(): string {
    return ProjectLinks.LINK_ABOUT_US;
  }
}
